import { BadgeType } from '@amzn/stencil-react-components/badge';
import { ResponseResult } from '@amzn/gbsa-helios-typescript-client';

/**
 * Maps a question response result (PASS/FAIL/NA) to a Stencil BadgeType.
 *
 * Shared across features — audit question lists and the task detail
 * question panel both render result badges with the same mapping.
 */
export function getResultBadgeType(result: string | undefined | null): BadgeType {
  if (result === ResponseResult.PASS) return BadgeType.Positive;
  if (result === ResponseResult.FAIL) return BadgeType.Negative;
  return BadgeType.Neutral;
}
